/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Redux
import { RootReducerState } from "../reducers";

const siteSelector = (state: RootReducerState) => {
  return state.site.currentSite;
};

const siteConfigUserDataSelector = (state: RootReducerState) => {
  return state.site.currentSite?.storeCfg?.userData;
};
export { siteSelector, siteConfigUserDataSelector };
